import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { styled } from '@components-shared/src/stitches';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { webappUriPath } from '@utils/url';

type BaseSectionHeaderProps = {
  header: string;
  userWebappUri: string;
  children?: React.ReactNode;
};

export const SectionHeader = (props: BaseSectionHeaderProps) => {
  const { header, children, userWebappUri } = props;

  return (
    <Container>
      <SectionDetails>
        <Header>
          <AccessibleLink pathnameUri={webappUriPath(userWebappUri)}>
            <StyledIconButton
              variant="tertiary"
              icon={<FontAwesomeIcon icon={faAngleLeft} size="lg" />}
            />
          </AccessibleLink>
          <h3>{header}</h3>
          {children}
        </Header>
      </SectionDetails>
    </Container>
  );
};

const StyledIconButton = styled(IconButton, {
  width: '8px !important',
});

const Container = styled('div', {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  paddingX: 24,
  marginTop: '$12',

  '@laptop': {
    paddingX: 0,
  },
});

const Header = styled('div', {
  display: 'flex',
  gap: 7,
  width: '100%',
  alignItems: 'center',
  svg: {
    cursor: 'pointer',
  },
  h3: {
    title: 'M',
    fontWeight: '500',
  },
  '@tablet': {
    h3: {
      title: 'XL',
      fontWeight: '500',
      fontSize: 32,
    },
  },
  '@laptop': {
    gap: 16,
  },
});

const SectionDetails = styled('div', {
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: 8,
});
